import React from 'react';
import { AVAILABLE_LOCALES, Locale } from '../../i18n';
import { useTranslation } from '../../i18n/hooks/useTranslation';

const LOCALE_LABELS: Record<Locale, string> = {
  en: 'EN',
  fr: 'FR',
  de: 'DE'
};

export function LanguageSelector() {
  const { locale, setLocale } = useTranslation();

  return (
    <div className="flex gap-2 px-4 py-3">
      {AVAILABLE_LOCALES.map((code) => {
        const isActive = locale === code;
        return (
          <button
            key={code}
            onClick={() => setLocale(code)}
            aria-pressed={isActive}
            aria-label={LOCALE_LABELS[code]}
            className={`flex-1 h-10 rounded-lg text-sm font-semibold transition-colors border ${
              isActive
                ? 'bg-gray-800 text-white border-gray-800'
                : 'bg-white text-gray-700 border-gray-300 hover:bg-gray-100'
            }`}
          >
            {LOCALE_LABELS[code]}
          </button>
        );
      })}
    </div>
  );
}
